import { useForm } from 'react-hook-form';
import Modal from '../../../Components/Modal/Modal';
import TimeOfDayInput from '../../../Components/TimeOfDayInput/TimeOfDayInput';
import { buildWorkoutCreatePayload, splitLocalDateTime } from './scheduling';

import styles from './CalendarPage.module.css';

import API from '../../../Utils/api';

export default function CreateWorkout({ user, data, closeCB, onSuccess, onFailure }) {
    const { register, handleSubmit } = useForm({
        defaultValues: {
            workoutDate: splitLocalDateTime(data.start).date,
            workoutTime: splitLocalDateTime(data.start).time
        }
    });

    const onEventCreate = async ({ workoutDate, workoutTime }) => {
        const payload = buildWorkoutCreatePayload(workoutDate, workoutTime);
        if (!payload) {
            onFailure('Please enter a valid start date and time!');
            return;
        }
        try {
            const { data } = await API.addUserWorkout(user._id, payload);
            onSuccess('Workout created!', data);
        } catch (err) {
            onFailure("Couldn't create workout!");
        }
    };

    return (
        <Modal
            closeCB={closeCB}
            title={'Create Workout'}
            footer={
                <button className='btn btn-primary' onClick={handleSubmit(onEventCreate)}>
                    Add
                </button>
            }
        >
            <form className={styles.form}>
                <div className='form-group'>
                    <label htmlFor='workoutDate'>Starting date</label>
                    <input
                        id='workoutDate'
                        type='date'
                        {...register('workoutDate', { required: true })}
                        className='form-control'
                        lang='en'
                    />
                </div>
                <div className='form-group'>
                    <TimeOfDayInput
                        id='workoutTime'
                        label='Starting time'
                        {...register('workoutTime', { required: true })}
                    />
                </div>
            </form>
        </Modal>
    );
}
